import { Component, OnInit,ViewChild} from "@angular/core";
import { NgImageSliderComponent } from 'ng-image-slider';
import {UtilityService} from 'src/app/services/utility.service'

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
})

export class LandingComponent implements OnInit {

  @ViewChild('nav', { static: false }) slider: NgImageSliderComponent;
  showModal = false;
  modalTitle:string="";
  modalDesc:string="";
  imgCollection:any;

  constructor(
   private utilityService:UtilityService
  ) {}

  ngOnInit(): void {
   this.imgCollection=this.utilityService.imgCollection
  //  console.log("imgCollection",this.imgCollection)
  }
  viewModal(idx){
    // console.log("toggleModal evt",idx)
    this.slider.autoSlide=false;
    this.slider.infinite=false;
    this.modalTitle=this.imgCollection[idx].title;
    this.modalDesc=this.imgCollection[idx].desc
    this.showModal = true;
  }
  closeModal(){
    this.showModal =false;
  }
  sendEmail(){
  }

}
